import { IStrings } from 'localization/IStrings';
import { SettlementProposalsTabType } from './SettlementProposalsTabType';

export const createSettlementProposalsTabTypeRecord = (strings: IStrings): Record<SettlementProposalsTabType, string> => {
	return {
		sps: strings.verzamelstaten,
		unhandled: strings.refundsToProcess,
	};
};
